import FileUpload from './Index.vue'

FileUpload.install = function(Vue) {
  Vue.component(FileUpload.name, FileUpload)
}

export default FileUpload
